




























import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import Velocity from "velocity-animate";

@Component
export default class EmbedYoutubePlayer extends Vue {
  /* Data */
  private setVideoId: string = '';
  private playerVars: any = {
    autoplay: 0,
    rel: 0
  };


  /* Property */
  @Prop() videoId: string;
  @Prop() isShown: boolean;
  @Prop() width: string;
  @Prop() autoPlay: boolean;


  /* Emit Events */
  @Emit('show')
  emitShow (): void {}

  @Emit('hide')
  emitHide (): void {}


  /* Computed Property */
  /**
   * YouTubePlayerの参照用Getter
   */
  get player (): any {
    const yt: any = this.$refs.youtube;
    return yt.player;
  }

  /**
   * ディレクティブプロパティから与えられた値によって設定される
   * プレイヤーのスタイルを返すGetter
   */
  get ytPlayerStyle (): any {
    const styleWidth: string = this.width ? this.width : '90%';
    return {
      width: styleWidth
    };
  }


  /* Custom Transition Hook */
  beforeEnter ($el: HTMLDivElement): void {
    $el.style.opacity = '0';
  }

  enter ($el: HTMLDivElement, done: Function): void {
    Velocity($el, {
      opacity: [1, 0],
      transform: ['translateY(0%)', 'translateY(10%)']
    }, {
      delay: 200,
      duration: 300,
      easing: 'easeOutSine',
      complete: () => {
        this.setVideoId = this.videoId;
        this.startVideo();
        this.$store.commit('pauseBgm');
        this.emitShow();
        done();
      }
    });
  }

  beforeLeave ($el: HTMLDivElement): void {
    $el.velocity('stop', true);
    this.player.stopVideo();
  }

  leave ($el: HTMLDivElement, done: Function): void {
    Velocity($el, {
      opacity: [0, 1],
      transform: ['translateY(10%)', 'translateY(0%)']
    }, {
      duration: 150,
      easing: 'linear',
      complete: () => {
        this.$store.commit('playBgm');
        this.emitHide();
        done();
      }
    });
  }


  /* Methods */
  /**
   * ビデオのスタート
   */
  private startVideo (): void {
    if (this.autoPlay) {
      this.player.playVideo();
    }
  }


  /* YouTubePlayer Events */
  private onYoutubePlayerCued (): void {
    console.log('YT Player Cue');
  }

}
